const lenis = new Lenis();

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

// Theme asset paths exposed from PHP (fallback to relative if not present)
const spriteUrl = (window.themeAssets && window.themeAssets.sprite) || "images/sprite.svg";

window.addEventListener("load", () => {
  ScrollTrigger.refresh();

  if (typeof lenis !== "undefined" && lenis.update) {
    lenis.update();
  }
});

// in-view detect
!(function () {
  const blocks = document.querySelectorAll("h1, h2, .subtitle, .in-view-detect, .fade-in-wrapper > *");
  const blocksLg = document.querySelectorAll(".in-view-detect-lg");

  [].forEach.call(blocks, ($item) => {
    function onScroll() {
      let delta = $item.getBoundingClientRect().top - window.innerHeight <= ($item.offsetHeight * -1) / 4 && !$item.classList.contains("in-view");

      if (delta) {
        setTimeout(() => {
          $item.classList.remove("in-view-detect");
          $item.classList.add("in-view");
        }, 200);
      }
    }
    onScroll();

    lenis.on("scroll", (e) => {
      onScroll();
    });
  });
  [].forEach.call(blocksLg, ($itemLg) => {
    function isLargeElementInViewport() {
      var rect = $itemLg.getBoundingClientRect();
      let delta = (rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) - (window.innerHeight || document.documentElement.clientHeight) / 2 && rect.right <= (window.innerWidth || document.documentElement.clientWidth)) || (rect.top < 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) - (window.innerHeight || document.documentElement.clientHeight) / 2);

      if (delta) {
        setTimeout(() => {
          $itemLg.classList.remove("in-view-detect-lg");
          $itemLg.classList.add("in-view");
        }, 400);
      }
    }

    isLargeElementInViewport();

    lenis.on("scroll", (e) => {
      isLargeElementInViewport();
    });
  });
})();

// build sliders from .logos-grid (if present)
(function buildLogosGridSliders() {
  const grid = document.querySelector(".logos-grid");
  if (!grid) return;

  const items = Array.from(grid.querySelectorAll("figure"));
  const half = Math.ceil(items.length / 2);
  const firstHalf = items.slice(0, half);
  const secondHalf = items.slice(half);

  function buildSlides(arr) {
    const list = [];
    while (list.length < 15) list.push(...arr);
    return list.slice(0, 15);
  }

  const sliderContainer = document.createElement("div");
  sliderContainer.className = "logos-grid-sliders";

  function createSlider(slides, cls) {
    const wrap = document.createElement("div");
    wrap.className = "slider-wrapper";

    const swiper = document.createElement("div");
    swiper.className = "swiper " + cls;

    const swiperWrapper = document.createElement("div");
    swiperWrapper.className = "swiper-wrapper";

    slides.forEach((fig) => {
      const slide = document.createElement("div");
      slide.className = "swiper-slide";
      slide.appendChild(fig.cloneNode(true));
      swiperWrapper.appendChild(slide);
    });

    swiper.appendChild(swiperWrapper);
    wrap.appendChild(swiper);
    sliderContainer.appendChild(wrap);
  }

  createSlider(buildSlides(firstHalf), "swiper-ticker-rtl");
  createSlider(buildSlides(secondHalf), "swiper-ticker-ltr");

  grid.parentNode.insertBefore(sliderContainer, grid.nextSibling);
})();

// init swipers after all assets (images) loaded
function initSwipers() {
  document.querySelectorAll(".swiper-ticker-ltr, .swiper-ticker-rtl").forEach((slider) => {
    const isGridSlider = slider.closest(".logos-grid-sliders") ? true : false;
    const rd = slider.classList.contains("swiper-ticker-rtl") ? false : true;

    const sw = new Swiper(slider, {
      slidesPerView: "auto",
      spaceBetween: isGridSlider ? 0 : 32,
      loop: true,
      speed: 7000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: rd,
      },
      breakpoints: {
        1024: {
          spaceBetween: isGridSlider ? 0 : 52,
        },
      },
      on: {
        init() {
          // small delay to allow Swiper internal clones/transforms to settle before refreshing ScrollTrigger
          setTimeout(() => {
            if (window.ScrollTrigger) {
              try {
                ScrollTrigger.refresh();
              } catch (e) {}
            }
          }, 50);
        },
      },
    });

    // Force autoplay start (fix for loop + delay:0 race)
    setTimeout(() => {
      try {
        sw.autoplay.start();
      } catch (e) {}
    }, 120);
  });
}

// Ensure Swiper initializes only after images/fonts loaded
if (document.readyState === "complete") {
  // page already loaded
  initSwipers();
} else {
  window.addEventListener("load", initSwipers);
}

// video testimonial lightbox
function getVideoEmbedUrl(url) {
  let parsed;
  try {
    parsed = new URL(url);
  } catch (e) {
    return null;
  }

  if (/(^|\.)vimeo\.com$/.test(parsed.hostname)) {
    const match = parsed.pathname.match(/^\/(\d+)/);
    if (match) {
      return `https://player.vimeo.com/video/${match[1]}?autoplay=1`;
    }
  }

  if (/(^|\.)youtube\.com$/.test(parsed.hostname)) {
    const id = parsed.searchParams.get("v");
    if (id && /^[\w-]{11}$/.test(id)) {
      return `https://www.youtube.com/embed/${id}?autoplay=1`;
    }
  }

  if (parsed.hostname === "youtu.be") {
    const id = parsed.pathname.slice(1);
    if (/^[\w-]{11}$/.test(id)) {
      return `https://www.youtube.com/embed/${id}?autoplay=1`;
    }
  }

  return null;
}

function buildVideoSlideHtml(embedUrl) {
  const wrapper = document.createElement("div");
  wrapper.className = "pswp__video-wrapper";

  const iframe = document.createElement("iframe");
  iframe.src = embedUrl;
  iframe.setAttribute("frameborder", "0");
  iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
  iframe.setAttribute("allowfullscreen", "");
  wrapper.appendChild(iframe);

  return wrapper.outerHTML;
}

if (
  typeof PhotoSwipeLightbox !== "undefined" &&
  document.querySelector(".js-video-lightbox")
) {
  // Snapshot the video links now, before Slick's infinite loop clones the
  // slides. Clones stay in the DOM permanently (not just during
  // transitions), so a selector-based gallery would count each testimonial
  // multiple times.
  const videoLinks = Array.from(document.querySelectorAll(".js-video-lightbox"));

  const videoLightbox = new PhotoSwipeLightbox({
    pswpModule: PhotoSwipe,
  });

  videoLightbox.addFilter("domItemData", (itemData, element) => {
    const embedUrl = getVideoEmbedUrl(element.dataset.videoUrl || "");
    if (embedUrl) {
      itemData.html = buildVideoSlideHtml(embedUrl);
      itemData.type = "html";
      itemData.width = 1620;
      itemData.height = 1080;
      // PhotoSwipe treats an item as an image whenever itemData.src is
      // present, regardless of itemData.type — drop it or the video HTML
      // is ignored and it tries (and fails) to load the href as an image.
      delete itemData.src;
      delete itemData.srcset;
    }
    return itemData;
  });

  // Bypass PhotoSwipeLightbox's built-in gallery/children click handling:
  // it always rebuilds dataSource from a live DOM scan on click
  // (overwriting the array above), so a click on a Slick clone — which
  // stays in the DOM even when it's the only copy currently visible —
  // could resolve to the wrong item or none at all. Resolving the index
  // ourselves via a stable id and opening with loadAndOpen() sidesteps
  // that scan entirely.
  document.addEventListener("click", (e) => {
    const clicked = e.target.closest(".js-video-lightbox");
    if (!clicked) return;
    const index = videoLinks.findIndex(
      (link) => link.dataset.testimonialId === clicked.dataset.testimonialId
    );
    if (index === -1) return;
    e.preventDefault();
    videoLightbox.loadAndOpen(index, videoLinks);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // parallax
  let parallaxAmount = window.innerHeight * 0.01;
  if (window.innerWidth < 1024) {
    parallaxAmount = window.innerHeight * 0.005;
  }
  document.querySelectorAll(".img-parallax img").forEach((img) => {
    gsap.set(img, {
      y: -parallaxAmount,
    });
    gsap.to(img, {
      y: parallaxAmount,
      scrollTrigger: {
        trigger: img,
        start: "top bottom",
        end: "bottom top",
        scrub: 1,
      },
    });
  });
  document.querySelectorAll(".bg-circle").forEach((circle) => {
    gsap.to(circle, {
      yPercent: -10,
      ease: "none",
      scrollTrigger: {
        trigger: circle,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });
  });

  // counter
  document.querySelectorAll(".counter").forEach((counter) => {
    function numberWithCommas(n) {
      var parts = n.toString().split(".");
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    const endValue = parseInt(counter.dataset.count.replace(/,/g, ""));

    ScrollTrigger.create({
      trigger: counter,
      start: "top 80%",
      onEnter: () => {
        gsap.fromTo(
          counter,
          { innerText: 0 },
          {
            innerText: endValue,
            duration: 2,
            ease: "power1.out",
            snap: { innerText: 1 },
            onUpdate: () => {
              counter.innerText = numberWithCommas(counter.innerText);
            },
          }
        );
      },
      once: true,
    });
  });

  if (document.querySelector(".tabs")) {
    const tabLinks = document.querySelectorAll(".tab-link");
    const tabContents = document.querySelectorAll(".tab-content");
    const tabsMenu = document.querySelector(".tabs-menu");
    const bg = document.createElement("span");
    bg.classList.add("tab-bg");
    tabsMenu.appendChild(bg);

    function moveBg(el) {
      const width = el.clientWidth;
      const left = el.getBoundingClientRect().left;
      const parentLeft = el.parentElement.getBoundingClientRect().left;

      bg.style.width = width + "px";
      bg.style.transform = `translateX(${left - parentLeft}px)`;
    }

    tabLinks.forEach((tab) => {
      tab.addEventListener("click", function () {
        tabLinks.forEach((btn) => btn.classList.remove("active"));
        tabContents.forEach((content) => content.classList.remove("active"));

        this.classList.add("active");
        document.getElementById(this.dataset.tab).classList.add("active");
        moveBg(this);

        setTimeout(() => {
          initStepTriggers();
        }, 50);
      });
    });

    const activeTab = document.querySelector(".tab-link.active");
    if (activeTab) {
      setTimeout(() => {
        moveBg(activeTab);
      }, 200);
    }
  }

  // steps
  let stepTriggers = [];

  function initStepTriggers() {
    // Kill old triggers
    stepTriggers.forEach((t) => t.kill());
    stepTriggers = [];

    const steps = document.querySelectorAll(".tab-content.active .step-item");
    const stepsLists = document.querySelectorAll(".tab-content.active .steps-list");

    stepsLists.forEach((stepsList) => {
      const trig = ScrollTrigger.create({
        trigger: stepsList,
        start: "top center",
        end: "bottom center",
        onLeave: () => removeActiveStepDown(),
        onLeaveBack: () => removeActiveStepUp(),
      });
      stepTriggers.push(trig);
    });

    steps.forEach((step, i) => {
      const trig = ScrollTrigger.create({
        trigger: step,
        start: "top center",
        end: "bottom center",
        onEnter: () => setActiveStep(i),
        onEnterBack: () => setActiveStep(i),
      });
      stepTriggers.push(trig);
    });

    ScrollTrigger.refresh();
  }

  function setActiveStep(activeIndex) {
    const steps = document.querySelectorAll(".tab-content.active .step-item");

    steps.forEach((step, i) => {
      step.classList.remove("active", "passed");

      if (i < activeIndex) step.classList.add("passed");
      if (i === activeIndex) step.classList.add("active");
    });
  }

  function removeActiveStepUp() {
    const steps = document.querySelectorAll(".tab-content.active .step-item");
    steps.forEach((step) => {
      step.classList.remove("active", "passed");
    });
  }

  function removeActiveStepDown() {
    const steps = document.querySelectorAll(".tab-content.active .step-item");
    steps.forEach((step) => {
      step.classList.remove("active");
      step.classList.add("passed");
    });
  }

  // init on load
  initStepTriggers();
});

//header
var header = document.querySelector(".header");

function getOffsetValue() {
  var headerHeight = document.querySelector(".header").clientHeight;

  return {
    up: 0,
    down: headerHeight,
  };
}

var headroom = new Headroom(header, {
  offset: getOffsetValue(),
});

headroom.init = function () {
  this.offset = getOffsetValue();

  window.addEventListener(
    "resize",
    () => {
      if (!this.initialised) {
        return;
      }

      this.initialised = false;
      this.scrollTracker.destroy();
      this.init();
    },
    {
      once: true,
    }
  );

  return Headroom.prototype.init.apply(this, arguments);
};

headroom.init();

jQuery(document).ready(function ($) {
  // menu
  function navOpen() {
    const scrollY = $(window).scrollTop();
    $("body").css({ position: "fixed", top: -scrollY });
    $(".navbar-toggler").addClass("active");
    $(".header").addClass("nav-opened");
    $(".header-menu-mobile").addClass("active");
    headroom.freeze();
  }
  function navClose() {
    const scrollY = document.body.style.top;
    $("body").css({ position: "initial", top: 0 });
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
    $(".navbar-toggler").removeClass("active");
    $(".header").removeClass("nav-opened");
    $(".header-menu-mobile").removeClass("active");
    headroom.unfreeze();
  }
  $(".header .navbar-toggler").on("click", function () {
    $(this).hasClass("active") ? navClose() : navOpen();
  });

  // reviews slider
  $(".s-reviews-slider .slider").on("init", function () {
    ScrollTrigger.refresh();
  });
  $(".s-reviews-slider .slider").slick({
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    initialSlide: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: true,
    prevArrow: $(".s-reviews-slider .slider-prev"),
    nextArrow: $(".s-reviews-slider .slider-next"),

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          initialSlide: 1,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          variableWidth: true,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          initialSlide: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          variableWidth: false,
          centerPadding: "24px",
        },
      },
    ],
  });

  // blog-slider
  $(".s-blog-slider .slider").on("init", function () {
    ScrollTrigger.refresh();
  });
  $(".s-blog-slider .slider").slick({
    infinite: true,
    dots: false,
    initialSlide: 0,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $(".s-blog-slider .slider-prev"),
    nextArrow: $(".s-blog-slider .slider-next"),

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          initialSlide: 1,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          initialSlide: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "60px",
        },
      },
    ],
  });

  // accordion
  $(".accordion-button").on("click", function () {
    const $item = $(this).closest(".accordion-item");
    const $body = $item.find(".accordion-body");

    if ($body.is(":visible")) {
      $body.slideUp(200);
      $item.removeClass("active");
    } else {
      $(".accordion-body").slideUp(200);
      $(".accordion-item").removeClass("active");
      $body.slideDown(200);
      $item.addClass("active");
    }
  });

  // sidebar navigation
  if ($(".content-nav").length) {
    $(".content-nav-toggler").on("click", function () {
      const $btn = $(this);
      const $nav = $btn.closest(".content-nav");
      const $list = $nav.find("ul");

      $btn.toggleClass("active");
      $list.stop(true, true).slideToggle(300);
    });

    $(".content-nav").each(function () {
      const $nav = $(this);
      const $list = $nav.find("ul");

      function buildAnchors(index, heading) {
        const $a = $("<a class='text-link'>");
        const $textSpan = $("<span class='link-text'>");
        const btnArrow1 = `<span class="link-icon-start"><svg width="15" height="12"><use xlink:href="${spriteUrl}#arrow-right"></use></svg></span>`;
        const btnArrow2 = `<span class="link-icon-end"><svg width="12" height="15"><use xlink:href="${spriteUrl}#arrow-down"></use></svg></span>`;
        const title = $(heading).text();
        const id = "section" + index;

        $(heading).attr("id", id);
        $a.attr("href", "#" + id);
        $textSpan.text(title);

        $a.append(btnArrow1).append($textSpan).append(btnArrow2);
        return $a;
      }

      const $headings = $(".text-content > h2");

      // Build nav links
      $headings.each(function (i, el) {
        const $a = buildAnchors(i, el);
        const $li = $("<li>");
        $li.append($a);
        $list.append($li);
      });

      // Smooth scroll on click
      $nav.find("a").on("click", function (e) {
        e.preventDefault();
        const target = document.querySelector($(this).attr("href"));
        if (target && typeof lenis !== "undefined") {
          lenis.scrollTo(target, {
            duration: 1,
            offset: document.querySelector(".header")?.clientHeight * -1 || 0,
          });
        }
      });
    });

    const $headings = $(".text-content > h2");

    if ($headings.length && $(".content-nav").length) {
      $headings.waypoint(
        function (direction) {
          if (direction === "down") {
            $(".content-nav .active").removeClass("active");
            const selector = `.content-nav a[href='#${this.element.id}']`;
            $(selector).parent().addClass("active");
          }
        },
        {
          offset: document.querySelector(".header")?.clientHeight || 0,
        }
      );

      $headings.waypoint(
        function (direction) {
          if (direction === "up") {
            $(".content-nav .active").removeClass("active");
            const selector = `.content-nav a[href='#${this.element.id}']`;
            $(selector).parent().prev().addClass("active");
          }
        },
        {
          offset: document.querySelector(".header")?.clientHeight || 0,
        }
      );
    }
  }

  // copy
  $(document).on("click", ".btn-copy", function () {
    const $btn = $(this);
    const link = window.location.href;

    navigator.clipboard.writeText(link).then(() => {
      // Add active class
      $btn.addClass("active");

      setTimeout(() => {
        $btn.removeClass("active");
      }, 5000);
    });
  });
});
